module.exports = __webpack_public_path__ + "static/media/logo-oscuro.44f97903.png";